<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content">
        <div class="title_button">
          <div class="go-back" @click="goBack" style="margin-right: 20px">返回</div>
          <div class="go-back" @click="membershipRenewal">缴费</div>
        </div>

        <!--          <div class="btn_box">-->
        <!--            <div class="main-title">缴费记录</div>-->
        <!--          </div>-->
        <div class="invitate-wrap">
          <!-- 列表 -->
          <div class="invitation-table">
            <el-table
                :data="tableData"
                :cell-style="{ textAlign: 'center' }"
                :header-cell-style="{
                background: '#EDF1F7',
                color: '#333',
                textAlign: 'center',
              }"
            >
              <el-table-column prop="sn" label="订单号"></el-table-column>
              <el-table-column prop="order_title" label="名称"></el-table-column>
              <el-table-column prop="committee_title" label="总会或分会">
              </el-table-column>
              <el-table-column prop="create_time" label="创建时间">
              </el-table-column>
              <el-table-column prop="pay_time" label="支付时间">
              </el-table-column>
              <el-table-column label="开票状态">
                <template slot-scope="scope">
                  <span class="status invoice1" v-if="scope.row.pay_status != 1"
                  >未付款</span
                  >
                  <template v-else>
                       <span class="status invoice1" v-if="scope.row.invoice_status == 0"
                       >未申请</span
                       >
                    <span class="status invoice2" v-if="scope.row.invoice_status == 1"
                    >开票中</span
                    >
                    <span class="status invoice3" v-if="scope.row.invoice_status == 2"
                    >已开票</span
                    >
                  </template>

                </template>
              </el-table-column>
              <el-table-column label="支付状态">
                <!--                0-待支付；1-已支付；2-待确认；9-已过期;-->
                <template slot-scope="scope">
                  <span class="status sicon1" v-if="scope.row.pay_status == 0"
                  >未支付</span>
                  <span class="status sicon2" v-if="scope.row.pay_status == 1"
                  >已支付</span>
                  <span class="status sicon3" v-if="scope.row.pay_status == 2"
                  >待确认</span>
                  <span class="status sicon9" v-if="scope.row.pay_status == 9"
                  >已过期</span>
                </template>
              </el-table-column>
              <el-table-column prop="buy_num" label="续费时长">
                <template slot-scope="scope">
                  {{ scope.row.buy_num }}年
                </template>
              </el-table-column>
              <el-table-column prop="order_amount" label="应付金额">
              </el-table-column>
              <el-table-column prop="actual_amount" label="实付金额">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="180">
                <template slot-scope="scope">
                  <el-button
                      @click.native.prevent="orderSee(scope.row)"
                      type="text"
                  >
                    查看订单
                  </el-button>
                  <el-button
                      v-if="scope.row.pay_status == 0"
                      @click.native.prevent="payMent(scope.row)"
                      type="text"
                      style="color: #ff4d4f"
                  >
                    支付
                  </el-button>
                  <el-button
                      v-if="scope.row.pay_status == 1 && scope.row.invoice_status == 0"
                      @click.native.prevent="applyFor(scope.row)"
                      type="text"
                  >
                    申请发票
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="paginationbox">
              <el-pagination
                  class="pagination"
                  v-if="total > 0"
                  background
                  @current-change="handleCurrentChange"
                  :current-page.sync="page_no"
                  :page-size="page_size"
                  layout="total, prev, pager, next, jumper"
                  :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" top="20vh" title="申请发票">
          <el-form label-position="left" :model="applyFor_form" :rules="applyFor_form_rules" ref="applyFor_form_ref">
            <el-row :gutter="24" style="display: flex;align-items: center">
              <el-col :span="16">
                <el-form-item label="发票抬头选择" prop="invoice_id">
                  <el-select v-model="applyFor_form.invoice_id" placeholder="请选择发票" clearable>
                    <el-option
                        v-for="item in invoiceList"
                        :key="item.id"
                        :label="item.header"
                        :value="item.id"
                    >
                    </el-option>
                  </el-select>

                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-button v-if="invoiceList.length==0" style="margin-left: 25px" type="primary" @click="toAdd()">
                  去创建
                </el-button>
              </el-col>
            </el-row>


          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button :disabled="logining" type="primary" @click="applyForSubmit('forget_form_ref')">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <el-dialog
        :visible.sync="paymentDialogShows"
        title="会员续费"
        class="header-dialog"
        width="750px"
        :lockScroll="false"
        :modal-append-to-body="false"
        :close-on-click-modal="false">
      <payment :payment_title="payment_title"></payment>
    </el-dialog>
    <el-dialog
        :visible.sync="paymentDialogShow"
        width="825px"
        class="paymentOnlineDialog"
        :close-on-click-modal="false"
        custom-class="payment-dialog"
        :append-to-body="true"
        top="15vh"
    >
      <p>订单信息</p>
      <div class="paymentOnlineDialog-infomation">
        <div class="flex">
          <p>订单号：</p>
          <p>{{ form.sn }}</p>
        </div>
        <div class="flex">
          <p>订单名称：</p>
          <p>{{ form.order_title }}</p>
        </div>
        <!--        <div class="flex">-->
        <!--          <p>订单金额：</p>-->
        <!--          <p style="color: #FF4D4F">￥{{ form.order_amount }}</p>-->
        <!--        </div>-->
        <div class="flex">
          <p>订单时间：</p>
          <p>{{ form.create_time }}</p>
        </div>
      </div>
      <p>支付方式</p>
      <div class="paymentOnlineDialog-method flex" v-loading="paymentLoading">
        <div class="left flex">
          <div class="paymentOnlinceDialog-QRCode"
               v-loading="QRCodeLoading"
               element-loading-text="加载中"
               element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.8)">
            <span v-if="payMethod != 2 && payMethod !== 3"></span>
            <img v-if="payMethod == 2 && QRCodeSrc !== ''" :src="QRCodeSrc" alt="">
            <iframe
                v-if="payMethod == 3 && aliPayForm != ''"
                :srcdoc="aliPayForm"
                frameborder="no"
                border="0"
                marginwidth="0"
                marginheight="0"
                scrolling="no"
                width="120"
                height="120"
                style="overflow: hidden"
            >
            </iframe>
          </div>
          <div>
            <p class="parmentOnlineDialog-title">在线支付</p>
            <div class="flex">
              <div v-for="(item, index) in paymentInfo" :key="index"
                   :class="['paymentOnlineDialog-channel', 'flex', payMethod == item.pay_config_id ? 'selected' : '']"
                   @click="handleSelectPayMethod(item.pay_config_id)">
                <img :src="item.icon" alt="">
                <div>{{ item.pay_way_name }}</div>
              </div>
            </div>
            <button class="paymentOnlineDialog-paidAlready" @click="handlePaidAlready">我已缴费</button>
          </div>
        </div>
        <div class="right">
          <div class="flex">
            <div class="paymentOnlineDialog-icon">￥</div>
            <p>对公转账</p>
          </div>
          <div class="paymentOnlineDialog-tips">选择对公转账方式后，订单有效期30天，请尽快完成转账</div>
          <button @click="handleShowCorporateTransfer">我要对公转账</button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :visible.sync="showCorporateTransfer"
        width="825px"
        class="corporateTransferDialog"
        :close-on-click-modal="false"
        :append-to-body="true">
      <div>
        <p>第一步 对公转账</p>
        <div class="corporateTransferDialog-info">
          <p>转账信息</p>
          <div class="flex">
            <p>收款人名称：</p>
            <p>{{ corporateTransferInfo.contacts }}</p>
          </div>
          <div class="flex">
            <p>收款人账号：</p>
            <p>{{ corporateTransferInfo.bank_account }}</p>
          </div>
          <div class="flex">
            <p>开户行名称：</p>
            <p>{{ corporateTransferInfo.sub_bank }}</p>
          </div>
          <div class="flex">
            <p>分行代码：</p>
            <p>{{ corporateTransferInfo.bank_code }}</p>
          </div>
          <div class="flex">
            <p>转账金额：</p>
            <p style="color: #FF4D4F">￥{{ orderAmount }}</p>
          </div>
          <button @click="handleCopy">复制转账信息</button>
        </div>
      </div>
      <div>
        <p>第二步 填写付款信息及上传付款回执</p>
        <el-form label-position="top" ref="corporateTransferForm_ref" :rules="corporateTransferFormRules"
                 :model="corporateTransferForm" @submit.native.prevent>
          <el-form-item label="付款方" prop="companyName">
            <el-input placeholder="请填写" v-model="corporateTransferForm.companyName"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="companyTel">
            <el-input placeholder="请填写" v-model.number="corporateTransferForm.companyTel"></el-input>
          </el-form-item>
          <el-form-item label="请上传付款回执" prop="paymentReceipt">
            <el-upload
                class="avatar-uploader"
                :action="$Url"
                :headers="imageUploadheaders"
                :show-file-list="false"
                :on-success="handleImageUploadSuccess"
                :on-error="handleImageUploadError"
                accept=".jpg, .png, .jpeg, .pdf">
              <el-image v-if="corporateTransferForm.paymentReceipt" fit="contain"
                        :src="corporateTransferForm.paymentReceipt" class="avatar"></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <button class="corporateTransferDialog-submit" @click="submitTransferInfo">提交</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCorporateTransferInfo,
  getPaymentMethod, getUnifiedOrderPayStatus,
  invoiceHeaderLists,
  Order_applyInvoic,
  order_lists, paymentByYear, setPrePaidOrder
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue";
import QRCode from "qrcode"; //左侧步骤条
import payment from '../views/payment.vue';

export default {
  components: {top, navMenu, payment},
  name: "productList",
  data() {
    return {
      form: {},
      paymentLoading: false,
      QRCodeLoading: false,
      showCorporateTransfer: false,
      paymentInfo: [],
      // 在线支付
      payMethod: -1,
      aliPayForm: '',
      // 对公转账
      corporateTransferInfo: {},
      orderAmount: '',
      QRCodeSrc: '',


      payment_title: '缴费',
      logining: false,
      applyFor_form: {
        sn: ''
      },
      applyFor_form_rules: {
        invoice_id: [{required: true, message: '请选择', trigger: ['blur', 'change']}],
      },
      invoiceList: [],
      type: JSON.parse(localStorage.getItem("userdata")).type,
      total: 1,
      page_no: 1,
      page_size: 10,
      loading: false,
      active: 1,
      tableData: [],
      page: 1,
      pagesize: 10,
      dialogVisible: false,
      title: "添加招聘",
      mark: "",
      paymentDialogShow: false,
      paymentDialogShows: false,


      corporateTransferForm: {
        companyName: '',
        companyTel: '',
        paymentReceipt: '',
        halfPaymentReceipt: '',
      },
      corporateTransferFormRules: {
        paymentReceipt: [
          {
            required: true,
            message: '请上传付款回执',
            trigger: 'blur'
          },
        ],
        // companyName: [
        //   {
        //     required: true,
        //     message: '请输入企业全称',
        //     trigger: 'blur'
        //   },
        // ],
        // companyTel: [
        //   {
        //     required: true,
        //     message: '请输入联系电话',
        //     trigger: 'blur'
        //   },
        //   {
        //     pattern: /^[0-9]{11}$/,
        //     message: '电话号码必须是数字且长度为11位',
        //     trigger: 'blur'
        //   }
        // ]
      },
      imageUploadheaders: {
        token: localStorage.getItem("token")
      },
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    // this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/PaymentManagement";
    });
    this.active = index;
    this.page = 1;
    this.mark = this.$route.query.mark;
    // 获取列表
    this.getList();
    this.getInvoiceList();
  },
  created() {

  },
  methods: {
    //zhang 跳转到支付页面
    payMent(row) {
      this.form = row
      this.getPayMethod()
      this.paymentDialogShow = true;
      this.timer()
    },
    timer() {
      if (this.paymentDialogShow == false) {
        return
      }
      setTimeout(async () => {
        const res = await getUnifiedOrderPayStatus(`sn=${this.form.sn}`);
        this.orderAmount = res.data.order_amount
        if (res.data.pay_status == '已支付') {
          this.$message.success('订单已支付成功');
          this.paymentDialogShow = false
          setTimeout(() => {
            window.location.reload()
          }, 1000);
        } else {
          this.timer();
        }
      }, 2000);
    },

    // 选择支付方式后，预支付并获取微信、支付宝二维码
    async handleSelectPayMethod(flag) {
      if (flag === this.payMethod) {
        return false;
      }
      this.QRCodeLoading = true;
      this.payMethod = flag;
      const data = {
        pay_way: flag,
        sn: this.form.sn,
        terminal: 4,
        client_type: `member_type${JSON.parse(localStorage.getItem('userdata')).type}`,
      }
      const res = await setPrePaidOrder(data);
      if (res.data.pay_way === 2) {
        QRCode.toDataURL(res.data.data).then(url => {
          this.QRCodeSrc = url;
          this.QRCodeLoading = false;
        });
      } else if (res.data.pay_way === 3) {
        this.aliPayForm = res.data.data;
        setTimeout(() => {
          this.QRCodeLoading = false;
        }, 1000)
      }

    },

    // 获取支付方式
    async getPayMethod() {
      let type = Number(JSON.parse(localStorage.getItem('userdata')).type);
      const res = await getPaymentMethod(`scene=${type + 1}`);
      this.paymentInfo = res.data.slice(0, 2); // 只拿前两项微信支付和支付宝支付
      this.paymentInfo.forEach(item => {
        item.pay_way_name = this.cutBeforeChar(item.pay_way_name, '（');
      })
      this.paymentLoading = false;
    },

    // 展示对公转账dialog并获取对公转账信息
    async handleShowCorporateTransfer() {
      this.payMethod = -1;
      setTimeout(() => {
        this.showPaymentOnline = false;
      }, 10)
      this.showCorporateTransfer = true;
      const res = await getCorporateTransferInfo(`client_type=member_type${JSON.parse(localStorage.getItem('userdata')).type}`);
      this.corporateTransferInfo = res.data
    },
    // 点击我已缴费
    async handlePaidAlready() {
      const res = await getUnifiedOrderPayStatus(`sn=${this.form.sn}`);
      if (res.data.pay_status == '已支付') {
        this.$message.success('订单已支付成功');
        this.showPaymentOnline = false
        setTimeout(() => {
          window.location.reload()
        }, 1000);
      } else {
        this.$message.warning('订单状态' + res.data.pay_status);
      }

    },
    timestampToDateString(timestamp) {
      if (timestamp) {
        let num = Number(timestamp)
        const date = new Date(num * 1000);
        return date.toLocaleDateString().replaceAll('/', '-')
      } else {
        return ''
      }
    },
    // 一键复制
    handleCopy() {
      let data = this.corporateTransferInfo;
      let text = `收款人名称：${data.contacts}\n收款人账号：${data.bank_account}\n开户行名称：${data.sub_bank}\n分行代码：${data.bank_code}\n转账金额：￥${this.orderAmount}`
      navigator.clipboard.writeText(text)
          .then(() => {
            this.$message.success('复制成功');
          })
          .catch(() => {
            this.$message.warning('复制失败');
          })
    },

    // 上传图片成功
    handleImageUploadSuccess(res, file, fileList) {
      this.$message.success('上传成功！')
      this.corporateTransferForm.paymentReceipt = res.data.uri;
      this.corporateTransferForm.halfPaymentReceipt = res.data.url;
    },
    // 上传图片失败
    handleImageUploadError() {
      this.$message.error('上传失败，请稍后再试！');
    },
    // 对公转账的预支付
    submitTransferInfo() {
      this.$refs['corporateTransferForm_ref'].validate(async (valid) => {
        if (valid) {
          const companyName = this.corporateTransferForm.companyName;
          const companyTel = String(this.corporateTransferForm.companyTel);
          if (companyName.trim() === '') {
            this.$message.error('企业全称不能为空！');
            return false;
          } else if (companyTel.trim() === '' || companyTel.trim().length !== 11) {
            this.$message.error('联系电话不能为空且必须为11位');
            return false;
          }
          const data = {
            pay_way: 4,
            sn: this.form.sn,
            terminal: 4,
            client_type: `member_type${JSON.parse(localStorage.getItem('userdata')).type}`,
            pay_voucher: this.corporateTransferForm.halfPaymentReceipt,
            payment_company: companyName,
            payment_mobile: companyTel
          }
          const res = await setPrePaidOrder(data);
          if (res.code == 1) {
            //   this.$message.success(res.data.data);
            this.$alert('您已成功提交缴费凭证，请等待确认订单，无需再次操作。', '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
            this.showCorporateTransfer = false;
            this.paymentDialogShow = false;
          }

        }
      })

    },

    // 截取字符串中某个字符之前的所有字符
    cutBeforeChar(str, char) {
      const index = str.indexOf(char);
      if (index === -1) {
        return str;
      }
      return str.substring(0, index);
    },


    // zhao 2024年10月30日16:15:23
    orderSee(row) {
      this.$router.push({
        path: "orderSee",
        query: {
          sn: row.sn
        }
      });
    },
    getInvoiceList() {
      let data = this.$qs.stringify({
        type: this.type,
        page_no: 1,
        page_size: 30,
      });
      invoiceHeaderLists(data)
          .then((res) => {
            if (res.code == 1) {
              this.invoiceList = res.data.lists;
            }
          })
          .catch((err) => {
            if (err.response.code != 401) {
              this.$message.warning(err.response);
            }
          });
    },
    //获取列表
    getList() {
      let data = this.$qs.stringify({
        type: this.type,
        page_no: this.page_no,
        page_size: this.page_size,
      });
      this.loading = true;
      order_lists(data)
          .then((res) => {
            if (res.code == 1) {
              this.tableData = res.data.lists;
              console.log(this.page_size, "this.page_size");
              this.tableData.forEach(item => {
                item.pay_time = this.timestampToDateString(item.pay_time)
              })
              this.total = res.data.count;
            }
          })
          .catch((err) => {
            if (err.response.code != 401) {
              this.$message.warning(err.response);
            }
          });
    },
    applyFor(row) {
      this.applyFor_form.sn = row.sn
      this.dialogVisible = true
    },
    applyForSubmit() {
      this.logining = true
      Order_applyInvoic(this.applyFor_form)
          .then((res) => {
            this.logining = false
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.getList();
              this.dialogVisible = false
            }
          })
          .catch((err) => {
            this.logining = false
            if (err.response.code != 401) {
              this.$message.warning(err.response);
            }
          });
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    toAdd() {
      this.$router.push({
        path: '/InvoiceManage',
      });
    },
    // 去缴费
    async membershipRenewal() {
      const res = await paymentByYear()
      if (res.code == 1) {
        this.$nextTick(() => {
          this.paymentDialogShows = true;
        })
      } else if (res.code == 0) {
        this.$message.warning(res.msg);
      }
      // if(this.userInfor.audit_status!=4) return  this.$message.warning('非正式会员不能续费');

    },
    // 分页相关
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.paginationbox {
  width: 100%;
  //position: absolute;
  bottom: 30px;
  left: 0;
}

.status {
  display: inline-block;
  width: 56px;
  height: 24px;
  border-radius: 6px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  text-align: center;
  line-height: 24px;
}

.sicon1 {
  background: #ff4d4f;
}

.sicon2 {
  background: #0091ff;
}

.sicon3 {
  background: #ffb800;
}

.sicon9 {
  background: #cccccc;
}

.invoice1 {
  background: #cccccc;
}

.invoice2 {
  background: #ffb800;
}

.invoice3 {
  background: #52C41A;
}

.btn_box {
  margin-top: 30px;
}

.header-dialog .el-icon-close:hover {
  color: #E40080;
}

.header-dialog .el-dialog__header {
  padding-bottom: 0;
}

.header-dialog .el-dialog__body {
  padding-top: 0;
}

.header-dialog {
  overflow-y: hidden;
}

.header-dialog .el-dialog {
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

///deep/.el-dialog{
//  margin-top: 0 !important;
//  position: absolute;
//  top: 40%;
//  left: 50%;
// min-width: 300px;
//  max-width: 600px;
//  transform: translate(-50%, -50%);
//}


.flex {
  display: flex;
  //justify-content: space-between;
}

.main1 {
  overflow: hidden;
  background: #FFF;
  margin-top: 20px;
}

.content1 {
  font-family: PingFangSC, PingFang SC;
  font-size: 14px;
  color: #1D1D1D;
  margin: 0;
  width: 100%;
  border-radius: 0;
  height: auto;
  background-color: #FFF;;

  .payment {
    border-bottom: 1px solid #EEE;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }

  .payment-information {
    margin-top: 18px;

    > p {
      font-weight: 500;
      margin-right: 10px;
    }

    > div {
      color: #555;

      div {
        margin-bottom: 8px;
      }

      div:last-child {
        margin-bottom: 0;
      }
    }
  }

  .payment-price {
    align-items: center;
    margin-top: 18px;

    p {
      font-weight: 500;
      margin-right: 10px;
    }

    div {
      color: #FF4D4F;
      font-size: 18px;
      font-weight: 700;
    }
  }

  .pay {
    width: 128px;
    height: 36px;
    background: linear-gradient(90deg, #F27FC0 0%, #E40080 100%);
    border: none;
    color: #fff;
    font-size: 14px;
    border-radius: 8px;
    cursor: pointer;
  }
}

.payment-dialog .el-dialog__body {
  p {
    font-weight: 500;
    color: #1D1D1D;
    margin-bottom: 10px;
  }

  .paymentOnlineDialog-infomation {
    width: 100%;
    background-color: #F7F9FA;
    box-sizing: border-box;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;

    .flex:last-child p {
      margin-bottom: 0;
    }

    p {
      color: #555;
    }
  }

  .paymentOnlineDialog-method {
    height: 120px;

    .left {
      padding-right: 80px;
      border-right: 1px solid #EEE;

      .paymentOnlinceDialog-QRCode {
        width: 120px;
        height: 120px;
        margin-right: 15px;

        > span {
          width: 100%;
          height: 100%;
        }

        > img {
          width: 100%;
          height: 100%;
        }

        > iframe {
          width: 100%;
          height: 100%;
        }
      }

      .parmentOnlineDialog-title {
        margin-top: 10px;
      }

      .paymentOnlineDialog-channel {
        width: 98px;
        height: 36px;
        box-sizing: border-box;
        border: 1px solid #EEE;
        margin-right: 10px;
        cursor: pointer;

        img {
          width: 20px;
          height: 20px;
          margin-left: 9px;
          margin-top: 8px;
        }

        div {
          font-size: 12px;
          color: #000;
          line-height: 36px;
          margin-left: 3px;
        }
      }

      .paymentOnlineDialog-channel.selected {
        border-color: #E40080;
      }

      .paymentOnlineDialog-channel:hover {
        border-color: #E40080;
      }

      .paymentOnlineDialog-paidAlready {
        margin-top: 10px;
        border: 1px solid #eee;
        width: 253px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: #fff;
        font-size: 14px;
        cursor: pointer;
      }

      .paymentOnlineDialog-paidAlready:hover {
        border-color: #E40080;
      }
    }

    .right {
      padding-left: 64px;

      > .flex {
        align-items: center;
        margin-top: 10px;

        .paymentOnlineDialog-icon {
          width: 20px;
          height: 20px;
          background-color: #FA7214;
          line-height: 20px;
          text-align: center;
          color: #fff;
          border-radius: 50%;
          font-weight: 700;
          font-size: 20px;
        }

        p {
          margin: 0;
          margin-left: 5px;
        }
      }

      .paymentOnlineDialog-tips {
        width: 228px;
        font-size: 12px;
        color: #555;
        margin-left: 25px;
        line-height: 17px;
        margin-top: 5px;
      }

      button {
        width: 253px;
        height: 36px;
        background: #fff;
        border: 1px solid #eee;
        font-size: 12px;
        margin-top: 10px;
        cursor: pointer;
      }

      button:hover {
        border-color: #E40080;
      }
    }
  }
}

.corporateTransferDialog {
  /deep/ .el-dialog__body {
    display: flex;

    > div {
      width: 50%;

      p {
        font-size: 14px;
        color: #1D1D1D;
        font-weight: 500;
        margin-bottom: 20px;
      }

      .corporateTransferDialog-info {
        padding: 20px;
        background-color: #F7F9FA;

        .flex {
          margin-bottom: 20px;

          p {
            color: #555;
            margin-bottom: 0
          }
        }

        .flex:nth-child(6) {
          margin-bottom: 0;
        }

        button {
          margin: 0;
          width: 108px;
          height: 36px;
          background-color: #fff;
          color: #333;
          font-size: 12px;
          border-radius: 8px;
          border: 1px solid #CAD2DD;
          cursor: pointer;
          margin-top: 70px;
        }

        button:hover {
          border-color: #E40080;
        }
      }

      .corporateTransferDialog-submit {
        height: 36px;
        width: 128px;
        border: none;
        background: linear-gradient(90deg, #F27FC0 0%, #E40080 100%);
        text-align: center;
        line-height: 36px;
        border-radius: 8px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        margin-top: 8px;
        float: right;
      }
    }

    > div:first-child {
      padding-right: 40px;
      box-sizing: border-box;
    }
  }
}

/deep/ .el-dialog {
  border-radius: 8px;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/deep/ .el-dialog__header {
  padding: 0;
}

/deep/ .el-dialog__body {
  padding: 20px;
}

/deep/ .el-form-item__label {
  font-size: 14px;
  color: #555;
  height: 20px;
  line-height: 20px;
  margin-bottom: 5px;
}

/deep/ .el-input {
  border-radius: 8px;
  height: 36px;
}

/deep/ .el-input .el-input__inner:hover {
  border-color: #E40080;
}

/deep/ .el-form-item {
  margin-bottom: 20px;
}

///deep/ .el-form-item__label::after{
//  content: '*';
//  color: #FF4D4F;
//  margin-left: 2px;
//}
/deep/ .el-icon-close:hover {
  color: #E40080;
}

/deep/ .el-icon-loading {
  color: #E40080;
}

/deep/ .el-loading-text {
  color: #E40080;
}

.avatar-uploader {
  width: 220px;
  height: 130px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
  margin: 0;
}

.avatar {
  width: 220px;
  height: 130px;
  display: block;
  border-radius: 8px;
}

.footer {
  display: flex;
  justify-content: space-around;
}

/deep/ .el-dialog__header {
  text-align: center !important;
  margin: 20px;
}

/deep/ .el-dialog__body {
  padding: 0 !important;
}

/deep/ .el-dialog {
  padding: 20px !important;
}

.title_button {
  display: flex;
  margin-bottom: 30px;
}

.title_button div:nth-child(2) {
  background: #F7A1A9;
  color: #ffffff;
}
</style>
